import { render, staticRenderFns } from "./subscribe_segment_form.vue?vue&type=template&id=5cf6fa8e&scoped=true&"
import script from "./subscribe_segment_form.vue?vue&type=script&lang=js&"
export * from "./subscribe_segment_form.vue?vue&type=script&lang=js&"
import style0 from "./subscribe_segment_form.vue?vue&type=style&index=0&id=5cf6fa8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf6fa8e",
  null
  
)

export default component.exports